import md5 from 'md5';

export function getRandomNumbers() {
  if (window.crypto) {
    const array = new Uint8Array(16);
    window.crypto.getRandomValues?.(array);
    return md5(array);
  }
  return md5(Date.now().toString());
}
